/* bespoke-landing.js — scroll-reveal, UTM, dataLayer, sticky CTA */
(function () {
  "use strict";
  window.dataLayer = window.dataLayer || [];

  /* 0. Scroll-reveal (IntersectionObserver) */
  if ("IntersectionObserver" in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible");
          revealObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.10, rootMargin: "0px 0px -40px 0px" });
    document.querySelectorAll(".reveal").forEach(function(el) {
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll(".reveal").forEach(function(el) {
      el.classList.add("is-visible");
    });
  }

  /* 1. UTM capture & persistence */
  var UTM_KEYS = ["utm_source","utm_medium","utm_campaign","utm_content","utm_term"];
  function captureUTMs() {
    var params = new URLSearchParams(window.location.search);
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem("argmac_utm") || "{}"); } catch(e) { stored = {}; }
    var changed = false;
    UTM_KEYS.forEach(function(k) {
      var v = params.get(k);
      if (v) { stored[k] = v; changed = true; }
    });
    if (changed) {
      try { sessionStorage.setItem("argmac_utm", JSON.stringify(stored)); } catch(e) {}
    }
    return stored;
  }
  var utms = captureUTMs();

  function decorateLinks() {
    var keys = Object.keys(utms);
    if (!keys.length) return;
    document.querySelectorAll('a[href*="argmac.com/products/"]').forEach(function(a) {
      try {
        var url = new URL(a.href);
        keys.forEach(function(k) { url.searchParams.set(k, utms[k]); });
        var piece = a.getAttribute("data-piece");
        if (piece) {
          var map = { Velar:"lp_featured_velar", Negrosno:"lp_featured_negrosno", Aurum:"lp_featured_aurum", Vindsor:"lp_featured_vindsor" };
          if (map[piece]) url.searchParams.set("utm_content", map[piece]);
        }
        a.href = url.toString();
      } catch(e) {}
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", decorateLinks);
  } else {
    decorateLinks();
  }

  /* 2. dataLayer event pushes */
  var EVENT_META = {
    dm_click_hero:         { event_category:"cta", event_label:"hero" },
    dm_click_conversation: { event_category:"cta", event_label:"conversation_block" },
    viewing_click:         { event_category:"cta", event_label:"viewing" },
    pdp_click_featured:    { event_category:"navigation", event_label:"featured_pieces" },
    whatsapp_click_lp:     { event_category:"cta", event_label:"whatsapp" },
    phone_click_lp:        { event_category:"cta", event_label:"phone" }
  };
  document.querySelectorAll("[data-event]").forEach(function(el) {
    el.addEventListener("click", function() {
      var name = el.getAttribute("data-event");
      var meta = EVENT_META[name] || {};
      var payload = { event: name };
      for (var k in meta) payload[k] = meta[k];
      if (name === "pdp_click_featured") {
        var piece = el.getAttribute("data-piece");
        payload.piece_name = piece || "";
      }
      window.dataLayer.push(payload);
    });
  });

  /* 3. Scroll depth (50% / 90%) */
  var fired = { 50: false, 90: false };
  window.addEventListener("scroll", function() {
    var doc = document.documentElement;
    var height = doc.scrollHeight - window.innerHeight;
    if (height <= 0) return;
    var pct = ((window.scrollY || doc.scrollTop) / height) * 100;
    if (!fired[50] && pct >= 50) {
      fired[50] = true;
      window.dataLayer.push({ event:"lp_50_scroll", event_category:"engagement" });
    }
    if (!fired[90] && pct >= 90) {
      fired[90] = true;
      window.dataLayer.push({ event:"lp_90_scroll", event_category:"engagement" });
    }
  }, { passive: true });

  /* 4. Sync hero height to full header height (announcement bar + nav) */
  function syncHeroHeight() {
    /* data-section-type="header" wraps announcement bar + toolbar + nav */
    var headerSection = document.querySelector('[data-section-type="header"]');
    var h;
    if (headerSection) {
      /* getBoundingClientRect().bottom = distance from viewport top to header bottom */
      h = Math.round(headerSection.getBoundingClientRect().bottom);
    } else {
      var fallback = document.getElementById('HeaderWrapper') ||
                     document.getElementById('SiteHeader') ||
                     document.querySelector('.site-header');
      h = fallback ? Math.round(fallback.getBoundingClientRect().bottom) : 0;
    }
    if (h > 0) {
      document.documentElement.style.setProperty('--bsp-header-h', h + 'px');
    }
  }
  /* Run immediately, then again after fonts settle, and on resize */
  syncHeroHeight();
  setTimeout(syncHeroHeight, 200);
  window.addEventListener('resize', syncHeroHeight, { passive: true });

  /* 5. Sticky mobile CTA reveal */
  var stickyBar = document.getElementById("bsp-sticky-cta");
  var heroEl = document.querySelector(".bsp-hero");
  function onStickyScroll() {
    if (!stickyBar || !heroEl) return;
    var past = (window.scrollY || document.documentElement.scrollTop) > heroEl.offsetHeight - 80;
    stickyBar.classList.toggle("is-visible", past);
    stickyBar.setAttribute("aria-hidden", past ? "false" : "true");
  }
  window.addEventListener("scroll", onStickyScroll, { passive: true });
  onStickyScroll();
})();

/* 6. Bespoke popup — 10-second trigger */
(function () {
  "use strict";

  var STORAGE_KEY = "bsp_popup_done";
  var DELAY_MS = 10000;

  function isEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  }

  function openPopup() {
    var backdrop = document.getElementById("bsp-popup-backdrop");
    if (!backdrop) return;
    backdrop.classList.add("is-open");
    backdrop.removeAttribute("aria-hidden");
    document.body.style.overflow = "hidden";
    var closeBtn = document.getElementById("bsp-popup-close");
    if (closeBtn) { setTimeout(function () { closeBtn.focus(); }, 50); }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "bsp_popup_open" });
  }

  function closePopup() {
    var backdrop = document.getElementById("bsp-popup-backdrop");
    if (!backdrop) return;
    backdrop.classList.remove("is-open");
    backdrop.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    try { sessionStorage.setItem(STORAGE_KEY, "1"); } catch (e) {}
  }

  function showSuccess() {
    var popup = document.querySelector(".bsp-popup");
    if (!popup) return;
    popup.querySelector(".bsp-popup__body").style.display = "none";
    document.getElementById("bsp-popup-form").style.display = "none";
    popup.querySelector(".bsp-popup__note").style.display = "none";
    var success = document.getElementById("bsp-popup-success");
    if (success) {
      success.removeAttribute("hidden");
      requestAnimationFrame(function() {
        requestAnimationFrame(function() { success.classList.add("is-visible"); });
      });
    }
    try { sessionStorage.setItem(STORAGE_KEY, "1"); } catch (e) {}
    window.dataLayer = window.dataLayer || [];
    setTimeout(closePopup, 4500);
  }

  function initPopup() {
    try { if (sessionStorage.getItem(STORAGE_KEY)) return; } catch (e) {}

    var backdrop = document.getElementById("bsp-popup-backdrop");
    if (!backdrop) return;

    /* Move to body so no ancestor stacking context breaks position:fixed */
    if (backdrop.parentElement !== document.body) {
      document.body.appendChild(backdrop);
    }

    document.getElementById("bsp-popup-close").addEventListener("click", closePopup);
    backdrop.addEventListener("click", function (e) {
      if (e.target === backdrop) { closePopup(); }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && backdrop.classList.contains("is-open")) { closePopup(); }
    });

    var form = document.getElementById("bsp-popup-form");
    var submitBtn = form.querySelector(".bsp-popup__submit");

    /* Override form.submit so when Shopify's captcha script calls it after
       hCaptcha verification, we intercept and do our fetch instead of navigating */
    form.submit = function () {
      var name    = document.getElementById("bsp-popup-name").value.trim();
      var contact = document.getElementById("bsp-popup-contact").value.trim();
      var product = document.getElementById("bsp-popup-product").value;
      var budget  = document.getElementById("bsp-popup-budget").value;

      var params = new URLSearchParams(new FormData(form)); /* includes h-captcha-response */
      params.set("contact[name]", name);
      params.set("contact[body]",
        "Product of interest: " + product + "\n" +
        "Budget: " + budget + "\n" +
        "Contact provided: " + contact + "\n" +
        "Source: Bespoke page popup"
      );
      if (isEmail(contact)) {
        params.set("contact[email]", contact);
      } else {
        params.set("contact[email]", "bespoke.lead@argmac.myshopify.com");
        params.set("contact[phone]", contact);
      }

      fetch("/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest",
          "Accept": "application/json, text/javascript, */*"
        },
        body: params.toString()
      })
      .then(function (res) {
        if (res.ok) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: "bsp_popup_submit", product_interest: product });
          showSuccess();
        } else {
          return res.text().then(function (t) { throw new Error(res.status + ": " + t.slice(0, 200)); });
        }
      })
      .catch(function (err) {
        console.error("[bespoke popup] submit failed:", err);
        submitBtn.disabled = false;
        submitBtn.textContent = "Send enquiry";
      });
    };

    form.addEventListener("submit", function (e) {
      var name    = document.getElementById("bsp-popup-name").value.trim();
      var contact = document.getElementById("bsp-popup-contact").value.trim();
      var product = document.getElementById("bsp-popup-product").value;
      var budget  = document.getElementById("bsp-popup-budget").value;

      /* Prevent submission if fields are empty */
      if (!name || !contact || !product || !budget) { e.preventDefault(); return; }

      submitBtn.disabled = true;
      submitBtn.textContent = "Sending…";

      /* Do NOT call e.preventDefault() here for valid submissions —
         Shopify's captcha script (document-level listener) intercepts this
         submit event, runs hCaptcha verification, injects h-captcha-response,
         then calls form.submit() which is our overridden fetch above */
    });

    setTimeout(openPopup, DELAY_MS);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPopup);
  } else {
    initPopup();
  }
})();
